module.exports = __webpack_public_path__ + "static/img/downloads.9032336.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/my/downloads.png
// module id = WbVe
// module chunks = 212